<template>
	<main class="complete">
		<div class="icon_wrapper">
			<img src="@/assets/img/common/complete.png" alt="구독해지 완료 아이콘" loading="lazy" />
			<div class="icon_title">
				<p>{{ UNSUBSCRIPTION_SUCCESS }}</p>
			</div>
		</div>
		<div class="c_fieldArea">
			<button
				class="c_button radius-x-small primary-fill save"
				@click="$router.replace(`/sub/payment-history/${route.params.subscription_pk}`)"
			>
				결제내역으로 돌아가기
			</button>
		</div>
	</main>
</template>

<script setup lang="ts">
// constant
// lib
import { useRoute } from 'vue-router';

import { UNSUBSCRIPTION_SUCCESS } from '@/constants/title';

// -----variable-----
const route = useRoute();
</script>

<style lang="scss" scoped>
.complete {
	display: flex;
	flex-direction: column;
	gap: var(--space-xx-large);
	max-width: 40rem;
	margin: 0 auto;
	justify-content: center;
	width: 100%;
	@media screen and (max-width: 1280px) {
		padding-left: 2rem;
		padding-right: 2rem;
	}
	img {
		width: 12rem;
	}
	.icon_wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--space-x-large);
		.icon_title {
			font-weight: var(--font-w-semi-bold);
			font-size: var(--space-large);
			line-height: 2.387rem;
		}
	}
	.c_fieldArea {
		button {
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			height: 4.8rem;
		}
	}
}
</style>
